"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@feature-hub/react");
const render = (extraParams, featureAppConfiguration, handle) => () => {
    const beforeCreate = (env) => {
        const faInLayerService = env.featureServices['fa-in-layer'];
        if (faInLayerService) {
            faInLayerService.closeLayer = () => {
                if (handle.closeLayer) {
                    handle.closeLayer();
                }
            };
            faInLayerService.params = extraParams;
        }
    };
    return (react_1.default.createElement(react_2.FeatureAppLoader, Object.assign({ featureAppId: featureAppConfiguration.name + '_in_layer', featureAppName: featureAppConfiguration.name }, featureAppConfiguration, { beforeCreate: beforeCreate })));
};
exports.render = render;
//# sourceMappingURL=render.js.map